/** Web Push-подписки текущей сессии: GET/PUT/DELETE /users/@me/push. */
import { authed } from './auth'

export interface PushInfo {
  enabled: boolean
  public_key: string
  subscriptions: { endpoint: string; user_agent: string; created_at: string; current: boolean }[]
}

export interface PushSubscriptionBody {
  endpoint: string
  keys: { p256dh: string; auth: string }
}

export const pushApi = {
  get: () => authed<PushInfo>('/users/@me/push'),
  subscribe: (body: PushSubscriptionBody) => authed<{ endpoint: string }>('/users/@me/push', { method: 'PUT', body: JSON.stringify(body) }),
  unsubscribe: (endpoint: string) => authed<void>('/users/@me/push', { method: 'DELETE', body: JSON.stringify({ endpoint }) }),
}
